import React from 'react'

import classNames from 'classnames'

import { Image } from 'v2/ui'

import { Box } from 'ui/components/Box'
import { BoxProps } from 'ui/components/Box/Box'
import { Icon } from 'ui/components/Icon'
import { RecipeProps } from 'ui/helpers/recipes'

import { ItemIconStyles } from './ItemIcon.css'

type ItemIconProps = BoxProps & {
    icon: NonNullable<WorkflowSchemaItemBase['icon']>
    iconUrl?: string
    colorScheme?: RecipeProps<typeof ItemIconStyles>['colorScheme']
}

export const ItemIcon: React.FC<ItemIconProps> = ({
    icon,
    iconUrl,
    colorScheme = 'Neutral',
    className,
    ...props
}) => {
    return (
        <Box
            width="3xl"
            height="3xl"
            flex
            center
            justifyContent="center"
            noShrink
            rounded="m"
            p={iconUrl ? 'xs' : undefined}
            className={classNames(ItemIconStyles.styleFunction({ colorScheme }), className)}
            {...props}
        >
            {iconUrl ? <Image src={iconUrl} alt="" /> : <RenderIcon icon={icon} />}
        </Box>
    )
}

type RenderIconProps = {
    icon: NonNullable<WorkflowSchemaItemBase['icon']>
}

export const RenderIcon: React.FC<RenderIconProps> = React.memo(({ icon }) => {
    if (icon === 'netsuite') {
        return <NetsuiteIcon />
    }

    return <Icon name={icon} size="s" family="hugeicons" />
})

const NetsuiteIcon = () => {
    return (
        <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.43359 4.11915H3.84093V9.84472H5.03952V12.0821H1.43359V4.11915ZM12.5764 9.38708H10.1691V3.66151H8.97049V1.42416H12.5764V9.38708Z"
                fill="currentColor"
            />
            <path
                d="M0.875 0.875H8.483V7.41415L5.55763 3.64117H0.875V0.875ZM13.125 12.6414H5.517V6.10225L8.44237 9.87523H13.125"
                fill="currentColor"
            />
        </svg>
    )
}
